export const DEV_MODE_STORAGE_KEY = "dust_dev_mode";

// Cached once at module load — no per-render localStorage reads. The
// localStorage typeof guard matters in vitest's jsdom, where `window` exists
// but localStorage can be undefined and this module is reached at import time
// (browsers always define it, so runtime behavior is unchanged).
export const DEV_MODE_ACTIVE =
  typeof window !== "undefined" &&
  typeof localStorage !== "undefined" &&
  localStorage.getItem(DEV_MODE_STORAGE_KEY) === "true";
